import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import { TooltipProps } from 'ant-design-vue'
import type ColumnManager from './column-manager.vue'

export interface columnManagerFieldItem {
  title: string // 别名
  key: string // 字段名
  isFixed?: boolean // 系统固定
  isHidden?: boolean // 是否隐藏
  isSensitive?: string //脱敏  说明：有值，表示出现眼睛图标，反之无值不出现
  initialDisplay?: boolean // 初始是否显示
  [key: string]: any
}

// 定义组件props
export const columnManagerProps = buildProps({
  open: {
    type: Boolean,
    default: false,
  },

  // 使用本地存储
  useLocalStorage: {
    type: Boolean,
    default: true,
  },

  // 本地存储key
  localKey: {
    type: String,
  },

  fieldList: {
    type: definePropType<columnManagerFieldItem[]>(Array),
    default: () => [],
  },
  // 最大展示数量
  maxCount: {
    type: Number,
    default: 0,
  },

  // 开启添加字段
  enableAddField: {
    type: Boolean,
    default: true,
  },

  // 添加字段文本
  addFieldText: {
    type: String,
  },
  // 管理器图标
  icon: {
    type: String,
  },

  // 气泡框位置
  placement: {
    type: definePropType<TooltipProps['placement']>(String),
  },

  // 最小宽度
  minWidth: {
    type: [Number, String],
  },
  // 最大高度
  maxHeight: {
    type: [Number, String],
  },
} as const)

// props
export type ColumnManagerProps = ExtractPropTypes<typeof columnManagerProps>

// instance
export type ColumnManagerInstance = InstanceType<typeof ColumnManager>
